import DTO from './DTO';
import { maxLength4, onlyDigits } from '../utils/validation';

class ViolationDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'violation',
        type: String,
        validators: {},
        labelKey: 'violation.violation',
      },
      {
        name: 'koap',
        type: String,
        validators: {},
        labelKey: 'violation.article',
      },
      {
        name: 'type',
        type: String,
        validators: {},
        labelKey: 'violation.type',
      },
      {
        name: 'status',
        type: String,
        validators: {},
        labelKey: 'status',
      },
      {
        name: 'uin',
        type: String,
        validators: {},
        labelKey: 'violation.uin',
      },
      {
        name: 'violation_date',
        type: String,
        validators: {},
        labelKey: 'violation.violation_date',
      },
      {
        name: 'resolution_at',
        type: String,
        validators: {},
        labelKey: 'violation.resolution_date',
      },
      {
        name: 'resolution_number',
        type: String,
        validators: {},
        labelKey: 'violation.resolution_number',
      },
      {
        name: 'resolution_creator_id',
        type: String,
        validators: {},
        labelKey: 'current.user',
      },
      {
        name: 'violation_place',
        type: String,
        validators: {},
        labelKey: 'violation.violation_place',
      },
      {
        name: 'sum',
        type: Number,
        validators: [maxLength4, onlyDigits],
        labelKey: 'violation.sum',
      },
      {
        name: 'vehicle_reg_number',
        type: String,
        validators: {},
        labelKey: 'violation.vehicle_reg_number',
      },
      {
        name: 'driver_id',
        type: String,
        validators: {},
        labelKey: 'violation.driver',
      },
      {
        name: 'carrier_name',
        type: String,
        validators: {},
        labelKey: 'carrier.name',
      },
      {
        name: 'driver_license',
        type: String,
        validators: {},
        labelKey: 'driver_license',
      },
      {
        name: 'lpn',
        type: String,
        validators: {},
        labelKey: 'vehicle_lpn',
      },
      {
        name: 'vehicle_id',
        type: String,
        validators: {},
        labelKey: 'violation.vehicle',
      },
      {
        name: 'applicant_id',
        type: String,
        validators: {},
        labelKey: 'violation.applicant',
      },
      {
        name: 'numberViolation',
        type: String,
        validators: {},
        labelKey: 'violation.numberViolation',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default ViolationDTO;
